<template>
  <div class="auth__container">
    <template v-if="!isActiveCreateSpace">
      <div class="h3 text-center mb-4 mb-sm-6">
        <template v-if="isFirstVisit">Благодарим за регистрацию</template>
        <template v-else>Экстранет</template>
      </div>
      <template v-if="!isDeclined">
        <p class="paragraph-s_h mb-4">
          Для работы с&nbsp;Экстранетом Алеан необходимо присоединиться к&nbsp;Пространству
        </p>
        <p class="paragraph-s_h mb-10 mb-sm-6">
          Вы&nbsp;можете вступить в&nbsp;действующее Пространство через приглашение, высланное администратором, или
          создать своё Пространство
        </p>
        <e-alert class="mb-10">
          <div>
            <p class="paragraph-m_h mb-1"><b>Внимание!</b></p>
            <p class="paragraph-s_h text-secondary">
              Не&nbsp;создавайте Пространство, если&nbsp;Вы должны получить приглашение. Дублирующиеся Пространства
              не&nbsp;будут одобрены администраторами Экстранета.
            </p>
          </div>
        </e-alert>
        <e-btn variant="primary" class="mt-auto mb-2 w-100 w-sm-auto" @click="toCreateSpace"
          >Создать Пространство</e-btn
        >
      </template>
      <template v-else>
        <v-img :src="DeclinedImage" width="160" height="160" />
        <div class="paragraph-s_h mt-6 mb-10">
          Пространство не прошло проверку. Вы можете обратиться в Поддержку:
          <a href="mailto:extranet@alean.ru" class="text-link">extranet@alean.ru</a>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="h3 text-center mb-4 mb-sm-6">Создание пространства экстранет</div>
      <p class="paragraph-m_h mb-4 mb-sm-10">
        Если вы работаете с&nbsp;нами, выберите «Действующий партнер» для&nbsp;ускоренного процесса создания
        пространства.
      </p>

      <select-menu :items="selectionMenu" />
    </template>
    <e-btn variant="link" class="mt-1 mt-sm-4" @click="logout">Выйти из учетной записи</e-btn>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, toRef } from 'vue';
import { useRoute } from 'vue-router';
import DeclinedImage from '@/assets/img/pages/signin/declined.svg';
import PersonCheckIcon from '@/assets/img/svg/person-check.svg?component';
import PersonPlusIcon from '@/assets/img/svg/person-plus.svg?component';
import SelectMenu from '@/core/components/common/SelectMenu.vue';
import { EAlert, EBtn } from '@/core/components/ui';
import { useServices } from '@/core/composables/services';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { UserRegistrationStatus } from '@/graphql/generated';
import { useAuthStore } from '@/parts/auth/store/auth';

const { $auth } = useServices();
const $route = useRoute();
const { profile } = useAuthStore();

const isActiveCreateSpace = ref(!!$route.query.create);

const selectionMenu = [
  {
    title: 'Новый партнер',
    to: { name: RouteNames.SignInMaster, query: { new: 1 } },
    icon: PersonPlusIcon,
  },
  {
    title: 'Действующий партнер',
    to: { name: RouteNames.SignInMaster },
    icon: PersonCheckIcon,
  },
];

const toCreateSpace = () => {
  isActiveCreateSpace.value = true;
};

const logout = () => {
  $auth.logout();
};

const isFirstVisit = sessionStorage.getItem('isFirstVisit');

const isDeclined = toRef(() => profile.value?.userRegistration?.status === UserRegistrationStatus.Declined);

onMounted(() => {
  sessionStorage.removeItem('isFirstVisit');
});
</script>

<style scoped lang="scss">
.auth {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;

    min-height: 100%;
  }

  &-hr {
    width: 92%;
    height: 2px;

    background: url('@/assets/img/common/line.png') repeat-x center center / 3px 100%;
  }
}
</style>
